<template>
  <div class="desc-image">
    <img :data-gifffer="image" class="image" v-if="gif">
    <img :src="image" class="image" v-else>
    <div class="desc-title">
      <slot name="desc"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescImage',
  props: {
    image: {
      require: true
    },
    gif: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style lang="scss" scoped>
@import './DescImage.scss';
</style>